<template>

  <el-row type="flex" justify="center" align="middle">
    <el-col align="center">
        <h1>About Xolas TMS</h1><br />
        <p>Version {{ver}}<br /></p>
        <br />
        <h2>For {{clientName}}</h2><br />
        <img :src="logo" style="width: 300px;height: auto"><br />
        <p>How to Use to the system <router-link to="help">User Guide</router-link></p>
        <p>Website <a href="https://www.xolas.io" target="_blank">xolas.io</a> </p>
        <p>Support <a href="https://support.xolas.io" target="_blank">support.xolas.io</a></p>
      </el-col>
  </el-row>

</template>

<script>

import {VERSION} from '@/components/Data'


export default {

  data () {
    return {
      ver: VERSION,
      logo: this.xolasClient().logoPath,
      clientName: this.xolasClient().name
    }
  }

}

</script>
